import { useEffect } from "react";
import HomeImageHero from "../assets/HomeImage.png";
import HomeImageHero1 from "../assets/HomeImage1.png";
import HomeImageHero2 from "../assets/HomeImage2.png";
import HomeImageHero3 from "../assets/HomeImage3.png";
import hhomecoverhero from "../assets/homecoverhero.svg";

import { IoMdLogIn } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import {
  FaFileInvoiceDollar,
  FaChartLine,
  FaUsersCog,
  FaStar,
  FaCogs,
  FaCut,
  FaUtensils,
} from "react-icons/fa";
import Contactus from "./Contactus";
import Magicqr_Google from "../assets/Magicqr_Google.mp4";
import google_map_review_ai from "../assets/google_map_review_ai.png";

function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        const yOffset = -100; // Offset for fixed navbar
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  const handleDemoLink = () => {
    window.open("https://crm.crmgeni.com/", "_blank");
  };

  return (
    <>
      <Helmet>
        <title>CRM Geni | Cloud Software Suite for Your Businesses</title>
        <meta
          name="description"
          content="Discover the ultimate invoice and CRM solution for your business. Streamline your operations, boost productivity, and drive growth with CRM Geni."
        />
        <meta
          name="keywords"
          content="CRM, invoicing, billing, SaaS, business management, CRM Geni"
        />
        <meta name="author" content="CRM Geni" />
        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Best Invoice & CRM Solution | CRM Geni"
        />
        <meta
          property="og:description"
          content="Simplify your sales, track expenses, and grow with CRM Geni."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://crmgeni.com/" />
        <meta
          property="og:image"
          content="https://crmgeni.com/WebsiteThumbnails.jpg"
        />{" "}
        {/* Replace with actual image URL */}
        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Best Invoice & CRM Solution | CRM Geni"
        />
        <meta
          name="twitter:description"
          content="Streamline your business operations with CRM Geni."
        />
        <meta name="twitter:image" content="https://crmgeni.com/og-image.png" />{" "}
        {/* Replace with actual image URL */}
        {/* Canonical URL */}
        <link rel="canonical" href="https://crmgeni.com/" />
      </Helmet>

      <section className="relative pt-24 pb-16 overflow-hidden bg-white">
        {/* Background Decorative Blobs */}
        <div className="absolute top-0 -left-4 w-72 h-72 bg-primary/10 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob"></div>
        <div className="absolute top-0 -right-4 w-72 h-72 bg-secoundry/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-20 w-72 h-72 bg-primary-STYLE1/20 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-4000"></div>

        <div className="relative flex items-center justify-center px-4 sm:px-8">
          <div className="flex flex-col lg:flex-row items-center justify-between w-full max-w-7xl gap-12 py-12">
            {/* Left Content */}
            <div className="w-full lg:w-1/2 animate-fade-in">
              <div className="mb-8">
                <div className="inline-block px-4 py-1.5 mb-6 text-sm font-semibold tracking-wide text-primary uppercase bg-primary/10 rounded-full">
                  Next-Gen CRM Solution
                </div>
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-[1.1] mb-6">
                  Your <span className="text-primary italic">Vision</span>,<br />
                  <span className="text-gradient">amplified by innovation.</span>
                </h1>
                <p className="text-gray-600 text-lg sm:text-xl max-w-xl leading-relaxed">
                  A powerful software platform to elevate your work. Designed for businesses and individuals committed to quality, privacy, and sustainable growth.
                </p>
              </div>

              <div className="flex flex-wrap gap-4 mb-10">
                <button
                  onClick={handleDemoLink}
                  className="bg-primary hover:bg-primary-100 text-white py-4 px-8 rounded-xl shadow-xl shadow-primary/20 transition-all duration-300 transform hover:-translate-y-1 flex items-center font-bold text-lg group"
                >
                  <IoMdLogIn className="mr-2 text-2xl group-hover:animate-wiggle" />
                  Get Started Free
                </button>

                <button
                  onClick={() => (window.location.href = "tel:8143407758")}
                  className="bg-white border-2 border-gray-100 hover:border-primary/30 text-gray-800 py-4 px-8 rounded-xl shadow-lg transition-all duration-300 transform hover:-translate-y-1 flex items-center font-bold text-lg group"
                >
                  <IoCall className="mr-2 text-2xl text-primary group-hover:animate-wiggle" />
                  Contact Sales
                </button>
              </div>

              <div className="relative mt-12 group">
                <div className="absolute -inset-1 bg-gradient-to-r from-primary to-primary-STYLE1 rounded-2xl blur opacity-25 group-hover:opacity-40 transition duration-1000 group-hover:duration-200"></div>
                <img
                  src={hhomecoverhero}
                  alt="Home"
                  className="relative rounded-2xl w-full object-cover shadow-2xl animate-float"
                />
              </div>
            </div>

            {/* Right Cards */}
            <div className="w-full lg:w-5/12 animate-fade-in animation-delay-2000">
              <div className="relative p-8 glass rounded-3xl border border-white/50 shadow-2xl">
                <div className="flex items-center justify-between mb-8">
                  <h3 className="text-xl font-bold text-gray-900">Featured Solutions</h3>
                  <div className="flex space-x-1">
                    <div className="w-2 h-2 rounded-full bg-red-400"></div>
                    <div className="w-2 h-2 rounded-full bg-yellow-400"></div>
                    <div className="w-2 h-2 rounded-full bg-green-400"></div>
                  </div>
                </div>

                <div className="space-y-4">
                  {[
                    {
                      icon: <FaCogs className="text-primary text-2xl" />,
                      title: "Smart CRM",
                      desc: "Tailored for unique business needs, including full sales pipeline.",
                      link: "https://crm.crmgeni.com",
                      color: "bg-blue-50"
                    },
                    {
                      icon: <FaUtensils className="text-primary text-2xl" />,
                      title: "Restaurants Pro",
                      desc: "Complete inventory, billing and daily performance analytics.",
                      link: "https://restaurants.crmgeni.com",
                      color: "bg-orange-50"
                    },
                    {
                      icon: <FaCut className="text-primary text-2xl" />,
                      title: "Salon Master",
                      desc: "Seamless scheduling and client history at your fingertips.",
                      link: "https://salons.crmgeni.com",
                      color: "bg-purple-50"
                    },
                  ].map((item, idx) => (
                    <a
                      href={item.link}
                      key={idx}
                      className="flex items-center justify-between p-5 bg-white/60 hover:bg-white border border-transparent hover:border-primary/20 rounded-2xl transition-all duration-300 group hover:shadow-xl shadow-sm"
                    >
                      <div className="flex items-center gap-4">
                        <div className={`p-3 rounded-xl ${item.color} group-hover:scale-110 transition-transform duration-300`}>
                          {item.icon}
                        </div>
                        <div>
                          <h4 className="text-base font-bold text-gray-900 group-hover:text-primary transition-colors">
                            {item.title}
                          </h4>
                          <p className="text-sm text-gray-500 leading-snug">
                            {item.desc}
                          </p>
                        </div>
                      </div>
                      <span className="p-2 rounded-full bg-gray-50 text-gray-400 group-hover:bg-primary group-hover:text-white transition-all duration-300 transform group-hover:translate-x-1">
                        →
                      </span>
                    </a>
                  ))}
                </div>

                <div className="mt-8 pt-8 border-t border-gray-100 flex items-center justify-between">
                  <div className="flex -space-x-3">
                    {[1, 2, 3, 4].map(i => (
                      <div key={i} className="w-10 h-10 rounded-full border-2 border-white bg-gray-200 overflow-hidden shadow-sm">
                        <img src={`https://i.pravatar.cc/100?u=${i}`} alt="user" />
                      </div>
                    ))}
                    <div className="w-10 h-10 rounded-full border-2 border-white bg-primary text-white flex items-center justify-center text-xs font-bold shadow-sm">+2k</div>
                  </div>
                  <p className="text-sm text-gray-500 font-medium">Trusted by 2,000+ businesses</p>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* ====== Products ====== */}

        {/* ====== Impact Section Start ====== */}
        <section className="relative py-24 bg-gray-50 overflow-hidden">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-3xl"></div>

          <div className="container relative mx-auto px-6">
            <div className="flex flex-col items-center max-w-4xl mx-auto text-center mb-20 animate-fade-in">
              <h2 className="text-sm font-bold tracking-widest text-primary uppercase mb-4">The CRM Geni Advantage</h2>
              <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-8 leading-tight">
                Supercharge Your Business with <br />
                <span className="text-gradient">Smart Invoicing & CRM!</span>
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto">
                Simplify your sales process, track expenses, and grow your business effortlessly with our all-in-one platform designed for modern entrepreneurs.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8 mb-16 px-4">
              {[
                { label: "Revenue Increase", value: "35%", sub: "Average growth in first year" },
                { label: "Time Saved", value: "20hrs", sub: "Weekly automation savings" },
                { label: "Customer Joy", value: "99%", sub: "High satisfaction rating" },
              ].map((stat, i) => (
                <div key={stat.label} className="bg-white p-10 rounded-3xl shadow-xl shadow-gray-200/50 border border-gray-100 flex flex-col items-center text-center transform hover:-translate-y-2 transition-all duration-300">
                  <span className="text-5xl font-black text-primary mb-2">{stat.value}</span>
                  <span className="text-lg font-bold text-gray-900 mb-1">{stat.label}</span>
                  <span className="text-sm text-gray-500 font-medium">{stat.sub}</span>
                </div>
              ))}
            </div>

            <div className="relative group max-w-5xl mx-auto">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary/20 to-primary-STYLE1/20 rounded-[40px] blur-2xl"></div>
              <div className="relative glass p-4 rounded-[32px] border border-white/80 shadow-2xl overflow-hidden">
                <div className="flex items-center gap-2 mb-4 px-4 pt-2">
                  <div className="w-3 h-3 rounded-full bg-red-400"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                  <div className="w-3 h-3 rounded-full bg-green-400"></div>
                  <div className="ml-4 w-64 h-4 bg-gray-100 rounded-full"></div>
                </div>
                <img
                  src={HomeImageHero}
                  alt="Dashboard Preview"
                  className="rounded-2xl w-full shadow-inner"
                />
              </div>
            </div>
          </div>
        </section>
        {/* ====== Impact Section End ====== */}


        {/* ====== Magic QR Section Starting ====== */}
        <section className="py-24 bg-gray-900 overflow-hidden rounded-[40px] mx-4 my-24 relative">
          <div className="absolute top-0 right-0 w-96 h-96 bg-primary/20 rounded-full blur-3xl"></div>

          <div className="container mx-auto px-6 relative z-10">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-16">
              <div className="lg:w-1/2 animate-fade-in">
                <span className="inline-block px-4 py-1.5 mb-6 text-sm font-bold tracking-widest text-primary-STYLE1 uppercase bg-primary-STYLE1/10 rounded-full">
                  Innovation Spotlight
                </span>
                <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-8 leading-tight">
                  Magic QR <span className="text-primary-STYLE1">Solution</span><br />
                  For Online Reputation
                </h2>
                <p className="text-xl text-gray-400 leading-relaxed mb-10">
                  Take control of your online presence. Our smart review system routes negative feedback privately for improvement, while pushing positive 4 and 5-star reviews directly to Google Maps.
                </p>
                <div className="flex gap-6">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-2xl bg-white/5 flex items-center justify-center text-primary-STYLE1">
                      <FaStar className="text-2xl" />
                    </div>
                    <span className="text-white font-bold">Smart Filtering</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-2xl bg-white/5 flex items-center justify-center text-primary-STYLE1">
                      <FaChartLine className="text-2xl" />
                    </div>
                    <span className="text-white font-bold">SEO Boost</span>
                  </div>
                </div>
              </div>

              <div className="lg:w-1/2 relative flex justify-center lg:justify-end">
                <div className="relative group">
                  <div className="absolute -inset-8 bg-primary/20 rounded-full blur-3xl animate-pulse"></div>
                  <div className="flex items-end gap-4 relative">
                    <img
                      src={google_map_review_ai}
                      alt="Review Management"
                      className="w-[220px] md:w-[280px] rounded-3xl shadow-2xl transform -rotate-6 group-hover:rotate-0 transition-transform duration-500"
                    />
                    <video
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="w-[160px] md:w-[200px] h-auto object-cover rounded-3xl shadow-2xl z-10 -ml-12 border-4 border-gray-900 transform rotate-3 group-hover:rotate-0 transition-transform duration-500"
                      src={Magicqr_Google}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ====== Magic QR Ending ====== */}



        {/* ====== Features Section Start ====== */}
        <section id="features" className="py-32 bg-white overflow-hidden">
          <div className="container mx-auto px-6">
            <div className="flex flex-col md:flex-row items-end justify-between mb-20 gap-8">
              <div className="max-w-2xl">
                <span className="inline-block px-4 py-1.5 mb-6 text-sm font-bold tracking-widest text-primary uppercase bg-primary/10 rounded-full">
                  Elite Features
                </span>
                <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
                  Streamline Your <br />
                  <span className="text-gradient">Business Operations</span>
                </h2>
              </div>
              <p className="text-xl text-gray-500 max-w-md leading-relaxed">
                Empower your team with a modern interface designed for speed, clarity, and uncompromising efficiency.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  icon: <FaFileInvoiceDollar className="text-white text-3xl" />,
                  title: "Smart Billing",
                  desc: "Automate invoices, track payments, and manage expenses in one place.",
                  color: "bg-primary"
                },
                {
                  icon: <FaChartLine className="text-white text-3xl" />,
                  title: "Real-time Analytics",
                  desc: "Visualize trends, profit margins, and lead performance instantly.",
                  color: "bg-primary-100"
                },
                {
                  icon: <FaUsersCog className="text-white text-3xl" />,
                  title: "Unified Management",
                  desc: "Handle customers, employees, and inventory with a single dashboard.",
                  color: "bg-gray-900"
                },
                {
                  icon: <FaStar className="text-white text-3xl" />,
                  title: "Premium Tools",
                  desc: "Unlock advanced AI recommendations and custom automation workflows.",
                  color: "bg-primary"
                }
              ].map((feature, i) => (
                <div key={feature.title} className="group relative p-1 bg-gradient-to-b from-gray-100 to-transparent rounded-3xl transition-all duration-500 hover:scale-[1.02]">
                  <div className="relative h-full p-10 bg-white rounded-[22px] shadow-sm group-hover:shadow-2xl transition-all duration-500">
                    <div className={`${feature.color} w-16 h-16 rounded-2xl flex items-center justify-center mb-8 shadow-lg group-hover:rotate-6 transition-transform duration-300`}>
                      {feature.icon}
                    </div>
                    <h5 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-primary transition-colors">
                      {feature.title}
                    </h5>
                    <p className="text-gray-500 leading-relaxed mb-8">
                      {feature.desc}
                    </p>
                    <button className="flex items-center gap-2 font-bold text-primary opacity-0 group-hover:opacity-100 -translate-x-4 group-hover:translate-x-0 transition-all duration-300">
                      Explore Feature <span className="text-xl">→</span>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* ====== Features Section Ending ====== */}

        {/* ====== Product Showcase Starting ====== */}
        <section className="py-24 bg-white">
          <div className="container mx-auto px-6 space-y-32">

            {/* Easy Billing */}
            <div className="flex flex-col lg:flex-row items-center gap-16">
              <div className="flex-1 animate-fade-in">
                <div className="inline-block px-4 py-1.5 mb-6 text-xs font-black tracking-widest text-primary uppercase bg-primary/10 rounded-full">
                  Step 01
                </div>
                <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
                  Easy <span className="text-gradient">Billing</span>,<br />
                  Smart Sharing!
                </h2>
                <p className="text-xl text-gray-600 leading-relaxed mb-8">
                  Creating invoices is now effortless! With just a click, you can generate professional bills, share them via WhatsApp or Email, and receive payments seamlessly.
                </p>
                <ul className="space-y-4">
                  {['One-click invoice generation', 'Direct WhatsApp sharing', 'UPI payment integration'].map(item => (
                    <li key={item} className="flex items-center gap-3 font-bold text-gray-800">
                      <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary text-sm">✓</div>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex-1 relative group">
                <div className="absolute -inset-4 bg-primary/5 rounded-[40px] blur-2xl group-hover:bg-primary/10 transition-colors duration-500"></div>
                <img alt="Easy Billing" src={HomeImageHero1} className="relative rounded-3xl shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500" />
              </div>
            </div>

            {/* Expenses */}
            <div className="flex flex-col lg:flex-row-reverse items-center gap-16">
              <div className="flex-1 animate-fade-in">
                <div className="inline-block px-4 py-1.5 mb-6 text-xs font-black tracking-widest text-primary-STYLE1 uppercase bg-primary-STYLE1/10 rounded-full">
                  Step 02
                </div>
                <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
                  Finance & <span className="text-gradient">Expense Tracking</span>
                </h2>
                <p className="text-xl text-gray-600 leading-relaxed mb-8">
                  Keep a pulse on your business health. Track every penny spent and earned with intuitive charts and detailed financial breakdowns.
                </p>
                <div className="p-6 bg-gray-50 rounded-2xl border border-gray-100 italic text-gray-500">
                  "Knowing where your money goes is the first step to scaling your business."
                </div>
              </div>
              <div className="flex-1 relative group">
                <div className="absolute -inset-4 bg-primary-STYLE1/5 rounded-[40px] blur-2xl group-hover:bg-primary-STYLE1/10 transition-colors duration-500"></div>
                <img alt="Expense Tracking" src={HomeImageHero2} className="relative rounded-3xl shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500" />
              </div>
            </div>

            {/* Employees */}
            <div className="flex flex-col lg:flex-row items-center gap-16">
              <div className="flex-1 animate-fade-in">
                <div className="inline-block px-4 py-1.5 mb-6 text-xs font-black tracking-widest text-primary uppercase bg-primary/10 rounded-full">
                  Step 03
                </div>
                <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
                  Effortless <span className="text-gradient">Team Management</span>
                </h2>
                <p className="text-xl text-gray-600 leading-relaxed mb-8">
                  Manage your biggest asset—your people. From attendance tracking to salary disbursements, take the complexity out of HR.
                </p>
                <button className="bg-gray-900 text-white py-4 px-10 rounded-2xl font-bold hover:bg-black transition-colors shadow-xl">
                  Explore HR Tools
                </button>
              </div>
              <div className="flex-1 relative group">
                <div className="absolute -inset-4 bg-primary/5 rounded-[40px] blur-2xl group-hover:bg-primary/10 transition-colors duration-500"></div>
                <img alt="Team Management" src={HomeImageHero3} className="relative rounded-3xl shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500" />
              </div>
            </div>

          </div>
        </section>
        {/* ====== Product Showcase Ending ====== */}



        {/* ====== SaaS CTA Section Start ====== */}
        <section className="relative py-24 mx-4 mb-24 rounded-[40px] bg-primary overflow-hidden shadow-2xl shadow-primary/30">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:40px_40px]"></div>
          </div>

          <div className="container relative mx-auto px-6 text-center">
            <div className="max-w-4xl mx-auto animate-fade-in">
              <h2 className="text-4xl md:text-6xl font-black text-white mb-8 leading-[1.1]">
                Need a Custom <span className="text-primary-STYLE1 underline decoration-white/20">SaaS Solution</span>?
              </h2>
              <p className="text-2xl text-white/80 font-medium mb-12">
                We don't just provide software; we build the future of your business. Let's create your custom platform together.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
                <button
                  onClick={() => (window.location.href = "tel:8143407758")}
                  className="w-full sm:w-auto bg-primary-STYLE1 text-gray-900 py-5 px-12 rounded-2xl font-black text-xl hover:scale-105 transition-transform shadow-xl shadow-black/20 flex items-center justify-center"
                >
                  <IoCall className="mr-3 text-2xl" />
                  Contact Our Experts
                </button>
                <div className="text-white/60 font-bold border-b border-white/20 pb-1">
                  Average response time: &lt; 2 hours
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ====== SaaS CTA Section end ====== */}



        {/* ====== Pricing Section Start ====== */}
        <section id="price-table" className="py-24 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="text-center max-w-3xl mx-auto mb-20 animate-fade-in">
              <h2 className="text-sm font-bold tracking-widest text-primary uppercase mb-4">Pricing Plans</h2>
              <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6">
                Transparent Pricing for <br />
                <span className="text-gradient">Every Business Stage</span>
              </h1>
              <p className="text-xl text-gray-600">Choose the plan that fits your current needs and scale when you're ready.</p>
            </div>

            <div className="grid lg:grid-cols-3 gap-10">
              {[
                {
                  title: "Starter",
                  price: "1250",
                  popular: false,
                  features: [
                    "Invoicing via WhatsApp",
                    "Expenditures Tracker",
                    "Customer Database",
                    "Full Analytics Report",
                    "QR Payment Gateway",
                  ],
                  users: "1",
                  color: "bg-white",
                  btnClass: "bg-gray-900 text-white"
                },
                {
                  title: "Mid-Range",
                  price: "1050",
                  popular: true,
                  features: [
                    "Complete Billing Solution",
                    "Separate Inventory",
                    "Leads Management",
                    "Magic QR for Reviews",
                    "Priority UPI Setup",
                  ],
                  users: "4",
                  color: "bg-primary text-white",
                  btnClass: "bg-primary-STYLE1 text-gray-900"
                },
                {
                  title: "Enterprise",
                  price: "1500",
                  popular: false,
                  features: [
                    "Full HR Management",
                    "AI Recommendations",
                    "Appointment System",
                    "Inventory System Pro",
                    "Dedicated Support",
                  ],
                  users: "10",
                  color: "bg-white border-2 border-primary/20",
                  btnClass: "bg-gray-900 text-white"
                },
              ].map((plan, index) => (
                <div key={plan.title} className={`relative p-10 rounded-[32px] shadow-2xl transition-all duration-500 hover:-translate-y-4 ${plan.color} ${plan.popular ? 'scale-110 z-10' : ''}`}>
                  {plan.popular && (
                    <div className="absolute top-0 right-10 -translate-y-1/2 bg-primary-STYLE1 text-gray-900 px-6 py-2 rounded-full font-black text-sm uppercase tracking-tighter shadow-lg">
                      Most Popular
                    </div>
                  )}
                  <h3 className="text-2xl font-bold mb-2 uppercase tracking-tight">{plan.title} Plan</h3>
                  <div className="flex items-baseline gap-1 mb-8">
                    <span className="text-5xl font-black italic">₹{plan.price}</span>
                    <span className="text-lg opacity-70">/mo</span>
                  </div>
                  <ul className="space-y-4 mb-10">
                    {plan.features.map(f => (
                      <li key={f} className="flex items-center gap-3">
                        <div className={`w-5 h-5 rounded-full flex items-center justify-center text-xs ${plan.popular ? 'bg-white/20 text-white' : 'bg-primary/20 text-primary'}`}>✓</div>
                        <span className="font-medium text-sm lg:text-base">{f}</span>
                      </li>
                    ))}
                  </ul>
                  <div className={`py-3 px-6 rounded-2xl mb-8 font-bold text-center ${plan.popular ? 'bg-white/10' : 'bg-gray-50'}`}>
                    {plan.users} Dedicated Users
                  </div>
                  <button className={`w-full py-4 rounded-2xl font-black text-lg transition-all shadow-lg hover:shadow-2xl ${plan.btnClass}`}>
                    Choose {plan.title}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* ====== Pricing Section End ====== */}


        {/* ====== Pricing Section End ====== */}

        {/* ====== Contact Section End ====== */}
        <section id="contact">
          <Contactus />
        </section>
        {/* ====== Contact Section End ====== */}

        {/* ====== FAQ Section Start ====== */}
        <section id="faq" className="py-24 bg-white">
          <div className="container mx-auto px-6">
            <div className="flex flex-col items-center mb-16 animate-fade-in">
              <span className="inline-block px-4 py-1.5 mb-6 text-sm font-bold tracking-widest text-primary uppercase bg-primary/10 rounded-full">
                Support Center
              </span>
              <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4 tracking-tight">
                Frequently Asked <span className="text-primary">Questions</span>
              </h2>
              <p className="text-xl text-gray-600">Everything you need to know about our platform.</p>
            </div>

            <div className="max-w-4xl mx-auto grid gap-4">
              {[
                { q: "What is Invoice & Payment Management?", a: "It's a comprehensive tool that allows you to create, track, and manage invoices and payments in real-time with automated reminders and deep integration." },
                { q: "How does Customer & Sales Management work?", a: "Our CRM module tracks every interaction, lead, and sale, giving you a 360-degree view of your customer journey from prospect to loyalty." },
                { q: "What is Product & Service Management?", a: "Easily catalog your offerings, manage inventory levels, and set dynamic pricing for different customer segments." },
                { q: "How does Expense Tracking work?", a: "Scan receipts, categorize spending, and generate P&L reports in seconds to keep your business profitable." },
                { q: "Is my data secure?", a: "We use bank-level encryption and regular security audits to ensure your business data is always safe and compliant with global standards." },
              ].map((faq, i) => (
                <details key={i} className="group glass border border-gray-100 rounded-[24px] overflow-hidden transition-all duration-300">
                  <summary className="flex items-center justify-between p-8 cursor-pointer list-none">
                    <span className="text-xl font-bold text-gray-900 group-open:text-primary transition-colors pr-8">
                      {faq.q}
                    </span>
                    <span className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center group-open:rotate-180 transition-transform duration-500">
                      <svg fill="none" height="20" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="20">
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </span>
                  </summary>
                  <div className="px-8 pb-8 pt-2 text-gray-600 leading-relaxed text-lg animate-fade-in">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
        {/* ====== FAQ Section End ====== */}

      </section>
    </>
  );
}

export default Home;
